(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cl-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cl-navigation')) {
    customElements.define('cl-navigation', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.panels = [...this.querySelectorAll('.cl-nav__details')];
        const closeAll = (except) => this.panels.forEach(panel => { if (panel !== except) panel.open = false; });
        this.panels.forEach(panel => {
          panel.addEventListener('toggle', () => {
            panel.querySelector('summary').setAttribute('aria-expanded', String(panel.open));
            if (panel.open) closeAll(panel);
          }, options);
          panel.addEventListener('pointerenter', (event) => {
            if (event.pointerType !== 'mouse' || !window.matchMedia('(hover: hover)').matches) return;
            clearTimeout(this.closeTimer);
            this.openTimer = setTimeout(() => { closeAll(panel); panel.open = true; }, 120);
          }, options);
          panel.addEventListener('pointerleave', () => {
            clearTimeout(this.openTimer);
            this.closeTimer = setTimeout(() => { if (!panel.contains(document.activeElement)) panel.open = false; }, 220);
          }, options);
          panel.addEventListener('focusout', () => {
            setTimeout(() => { if (!panel.contains(document.activeElement)) panel.open = false; }, 0);
          }, options);
        });
        document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) closeAll(); }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const openPanel = this.panels.find(panel => panel.open);
          if (openPanel) { openPanel.open = false; openPanel.querySelector('summary').focus(); event.stopPropagation(); }
        }, options);
      }
      disconnectedCallback() { this.abort?.abort(); clearTimeout(this.openTimer); clearTimeout(this.closeTimer); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cl-sticky-buy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cl-sticky-buy')) {
    customElements.define('cl-sticky-buy', class extends HTMLElement {
      connectedCallback() {
        this.product = document.getElementById(`MainProduct-${this.dataset.section}`);
        this.primary = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        this.action = this.querySelector('button');
        if (!this.product || !this.primary) return;
        this.action.addEventListener('click', () => { if (!this.primary.disabled) this.primary.click(); });
        this.sync = () => {
          this.action.disabled = this.primary.disabled;
          this.action.textContent = this.primary.querySelector('span')?.textContent.trim() || this.primary.textContent.trim();
          const amount = this.product.querySelector('.price__sale .price-item--sale');
          const regular = this.product.querySelector('.price__regular .price-item--regular');
          const sale = this.product.querySelector('.price--on-sale');
          this.querySelector('.cl-sticky-purchase__price').textContent = (sale ? amount : regular)?.textContent.trim() || '';
        };
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.product, { childList:true, subtree:true, attributes:true, attributeFilter:['disabled'] });
        this.visibility = new IntersectionObserver(entries => {
          this.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > window.innerHeight;
        });
        this.visibility.observe(this.primary);
        this.sync();
      }
      disconnectedCallback() { this.observer?.disconnect(); this.visibility?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
